import React, { useEffect, useState } from "react";
import "./common.css";
import { Form, Alert } from "react-bootstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import ErrorreqService from "../services/errorreq.service";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AuthService from "../services/auth.service";

const RaiseRequest = () => {
  const [raiseReq, setRaiseReq] = useState({
    issue: "",
    issuecat: "",
    attachment: "",
    description: "",
  });
  const [validated, setValidated] = useState(false);
  const [dataUpload, setDataUpload] = useState(false);
  const [errorImg, setErrorImg] = useState("");
  const [message, setMessage] = useState("");
  const [selectedOptions, setSelectedOptions] = useState();
  const [error, setError] = useState(false);
  const [errMessage, setErrMessage] = useState("");

  const [roleid, setRoleid] = useState("");

  const [userId, setUserId] = useState("");

  const [options, setOptions] = useState([
    { value: "Manage Learners", label: "Manage Learners" },
    { value: "Manage Courses", label: "Manage Courses" },
    { value: "Create Courses", label: "Create Courses" },
    { value: "Communication", label: "Communication" },
    { value: "Reports", label: "Reports" },
    { value: "Other", label: "Other" },
  ]);

  const [studentOptions, setStudentOptions] = useState([
    { value: "Courses", label: "Courses" },
    { value: "Assessment", label: "Assessment" },
    { value: "Payment", label: "Payment" },
    { value: "Other", label: "Other" },
  ]);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setUserId(user.user);
      setRoleid(user.role_id);
    }
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setRaiseReq({ ...raiseReq, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    setRaiseReq({ ...raiseReq, [name]: e.target.files[0] });
    // setErrorImg(URL.createObjectURL(e.target.files[0]));
    // setUploaded(true);
  };

  const handleSelectOptionChange = (selectedOption) => {
    setSelectedOptions(selectedOption);
    const value = selectedOption ? selectedOption.value : "";
    setRaiseReq({ ...raiseReq, issuecat: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);

      setError(true);
      setErrMessage("* Please fill all required fields!");

      setTimeout(() => {
        setError(false);
      }, 2000);
      return;
    }

    const formdata = new FormData();

    console.log("raiseReq.attachment", raiseReq.attachment);

    if (raiseReq.attachment) {
      formdata.append("issue", raiseReq.issue);
      formdata.append("issuecat", raiseReq.issuecat);
      formdata.append("attachment", raiseReq.attachment);
      formdata.append("description", raiseReq.description);
      formdata.append("usp", userId);
      formdata.append("date", Date());
    } else {
      formdata.append("issue", raiseReq.issue);
      formdata.append("issuecat", raiseReq.issuecat);
      formdata.append("description", raiseReq.description);
      formdata.append("usp", userId);
      formdata.append("date", Date());
    }

    ErrorreqService.createErrorReq(formdata)
      .then((response) => {
        toast.success("Request Raised Successfully!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        setRaiseReq({
          issue: "",
          issuecat: "",
          attachment: "",
          description: "",
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="box-outer addUser">
              <div className="box-inner">
                <div className="action-flex">
                  <div className="heading">
                    <h1>Raise a Request</h1>
                  </div>
                  <div className="courses-act">
                    <div className="action-item">
                      <Link to="/HelpNSupport">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 19.379 19.382"
                          >
                            <g
                              id="left-arrow-in-circular-button-black-symbol"
                              transform="translate(-0.6 511.567)"
                            >
                              <path
                                id="Path_13057"
                                data-name="Path 13057"
                                d="M9.381-511.546A9.911,9.911,0,0,0,4.162-509.4a11.83,11.83,0,0,0-1.457,1.468,10.165,10.165,0,0,0-1.878,3.88A8.145,8.145,0,0,0,.6-501.873a8.145,8.145,0,0,0,.228,2.181,10.088,10.088,0,0,0,1.931,3.945,11.828,11.828,0,0,0,1.468,1.457,10.164,10.164,0,0,0,3.88,1.878,8.146,8.146,0,0,0,2.181.228,8.146,8.146,0,0,0,2.181-.228,10.541,10.541,0,0,0,3.141-1.339A9.712,9.712,0,0,0,19-497.606a9.626,9.626,0,0,0,.914-2.94,12.941,12.941,0,0,0,0-2.655,9.626,9.626,0,0,0-.914-2.94,9.19,9.19,0,0,0-1.889-2.625,9.01,9.01,0,0,0-2.553-1.813,9.581,9.581,0,0,0-2.9-.91A14.607,14.607,0,0,0,9.381-511.546Zm1.1,5.618a.61.61,0,0,1,.25.766c-.03.068-.622.69-1.328,1.392L8.126-502.5l3.315.019c3.277.019,3.319.019,3.421.1a.536.536,0,0,1,.262.508.536.536,0,0,1-.262.508c-.1.08-.144.08-3.421.1l-3.315.019L9.4-499.977c.706.7,1.3,1.324,1.328,1.392a.607.607,0,0,1-.77.808c-.14-.053-3.683-3.588-3.751-3.744a1.386,1.386,0,0,1-.015-.683c.053-.133,3.581-3.679,3.736-3.751A.637.637,0,0,1,10.477-505.928Z"
                                transform="translate(0 0)"
                              />
                            </g>
                          </svg>
                        </span>
                        &nbsp;&nbsp;
                        <span>Back</span>
                      </Link>
                    </div>
                  </div>
                </div>
                {dataUpload ? (
                  <>
                    <Alert className="m-auto mb-5" variant="success">
                      {message}
                    </Alert>
                  </>
                ) : (
                  <></>
                )}
                {error ? (
                  <>
                    <Alert className="m-auto mb-5" variant="danger">
                      {errMessage}
                    </Alert>
                  </>
                ) : (
                  <></>
                )}
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  {dataUpload ? (
                    <>
                      <Alert className="m-auto mb-5" variant="success">
                        {message}
                      </Alert>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="add-user-form">
                    {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>What not Working? *</Form.Label>
                      <div className="input-box">
                        <Form.Control
                          type="text"
                          placeholder=""
                          name="issue"
                          value={raiseReq.issue}
                          onChange={handleInputChange}
                          required
                        />
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 20.199 20.201"
                          >
                            <g
                              id="Group_11227"
                              data-name="Group 11227"
                              transform="translate(-2402.326 -6200.833)"
                            >
                              <path
                                id="Path_11890"
                                data-name="Path 11890"
                                d="M1654.058,694.916h-1.132a2.254,2.254,0,0,0-1.595.662,2.23,2.23,0,0,0-.662,1.6V707.34a2.231,2.231,0,0,0,.662,1.6,2.254,2.254,0,0,0,1.595.662h10.165a2.259,2.259,0,0,0,2.256-2.26v-1.129"
                                transform="translate(752.656 5510.435)"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                              />
                              <path
                                id="Path_11892"
                                data-name="Path 11892"
                                d="M1665.659,691.509l3.389,3.389m1.563-1.6a2.373,2.373,0,0,0-3.356-3.355l-9.5,9.471V702.8h3.389Z"
                                transform="translate(751.221 5511.583)"
                              />
                            </g>
                          </svg>
                        </span>
                      </div>
                    </Form.Group> */}
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Issue Category *</Form.Label>
                      <div className="input-box">
                        {roleid === "4" ? (
                          <>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  border: "none",
                                  outline: "none",
                                  borderRadius: "10px",
                                  backgroundColor: state.isFocused
                                    ? "var(--dark-bg)"
                                    : "var(--dark-bg)",
                                  height: "45px",
                                }),
                                option: (
                                  baseStyles,
                                  { isFocused, isSelected }
                                ) => ({
                                  ...baseStyles,
                                  backgroundColor: isSelected
                                    ? "var(--primary-color)"
                                    : isFocused
                                    ? "var(--secondary-color)"
                                    : "var(--body-dark-bg)",
                                  color: isSelected
                                    ? "var(--body-dark-bg)"
                                    : isFocused
                                    ? "var(--body-dark-bg)"
                                    : "var(--whiteColor)",
                                }),
                              }}
                              onChange={handleSelectOptionChange}
                              value={selectedOptions}
                              options={studentOptions}
                              issearchable="true"
                              placeholder="Select Course Category"
                              required
                            />
                          </>
                        ) : (
                          <>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  border: "none",
                                  outline: "none",
                                  borderRadius: "10px",
                                  backgroundColor: state.isFocused
                                    ? "var(--dark-bg)"
                                    : "var(--dark-bg)",
                                  height: "45px",
                                }),
                                option: (
                                  baseStyles,
                                  { isFocused, isSelected }
                                ) => ({
                                  ...baseStyles,
                                  backgroundColor: isSelected
                                    ? "var(--primary-color)"
                                    : isFocused
                                    ? "var(--secondary-color)"
                                    : "var(--body-dark-bg)",
                                  color: isSelected
                                    ? "var(--body-dark-bg)"
                                    : isFocused
                                    ? "var(--body-dark-bg)"
                                    : "var(--whiteColor)",
                                }),
                              }}
                              onChange={handleSelectOptionChange}
                              value={selectedOptions}
                              options={options}
                              issearchable="true"
                              placeholder="Select Course Category"
                              required
                            />
                          </>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Attachments</Form.Label>
                      <div className="input-box attachment">
                        <Form.Control
                          type="file"
                          name="attachment"
                          onChange={handleFileChange}
                        />
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 28.121 25.217"
                          >
                            <g
                              id="upload-big-arrow"
                              transform="translate(-0.133 485.387)"
                            >
                              <path
                                id="Path_13620"
                                data-name="Path 13620"
                                d="M124.024-485.344a1.789,1.789,0,0,0-.412.181c-.088.066-1.66,1.621-3.489,3.462a34.115,34.115,0,0,0-3.407,3.561,1.163,1.163,0,0,0,.621,1.484,6.763,6.763,0,0,0,1.742.082h1.539l.016,4.413.016,4.413.165.324a1.649,1.649,0,0,0,.907.791c.286.082,4.88.082,5.165,0a1.649,1.649,0,0,0,.907-.791l.165-.324.016-4.413.016-4.413h1.539a6.763,6.763,0,0,0,1.742-.082,1.151,1.151,0,0,0,.572-1.572c-.176-.363-6.836-7-7.1-7.072A1.076,1.076,0,0,0,124.024-485.344Z"
                                transform="translate(-110.11 0)"
                                fill="#fff"
                              />
                              <path
                                id="Path_13621"
                                data-name="Path 13621"
                                d="M.978-266.72a1.463,1.463,0,0,0-.709.665c-.115.214-.115.264-.132,3.517A31.334,31.334,0,0,0,.208-258.7a5.987,5.987,0,0,0,4.786,4.962c.462.093,1.017.1,9.2.1s8.737-.005,9.2-.1a5.987,5.987,0,0,0,4.786-4.962,31.333,31.333,0,0,0,.071-3.841c-.016-3.253-.016-3.3-.132-3.517a1.4,1.4,0,0,0-2.511,0c-.121.214-.121.264-.148,3.654a24.571,24.571,0,0,1-.115,3.682,3.343,3.343,0,0,1-2.165,2.16l-.385.121H5.594l-.385-.121a3.343,3.343,0,0,1-2.165-2.16,24.572,24.572,0,0,1-.115-3.682c-.027-3.391-.027-3.44-.148-3.654A1.385,1.385,0,0,0,.978-266.72Z"
                                transform="translate(0 -206.535)"
                                fill="#fff"
                              />
                            </g>
                          </svg>
                        </span>
                      </div>
                    </Form.Group>
                    <Form.Group
                      className="mb-3"
                      controlId="formBasicDesignation"
                    >
                      <Form.Label>Description</Form.Label>
                      <div className="input-box">
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          name="description"
                          value={raiseReq.description}
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                    </Form.Group>
                  </div>
                  <ToastContainer />
                  <div className="act-btn">
                    <button>Submit</button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RaiseRequest;
